import React from "react";
import { Link } from "react-router-dom";
import { Flame, Gift, TrendingUp, Award, Sparkles, Zap, Clock } from "lucide-react";

const DEALS = [
  { label: "Big Sales", icon: Flame, to: "/market/search" },
  { label: "Free Available", icon: Gift, to: "/affiliate-program" },
  { label: "Trending Now", icon: TrendingUp, to: "/market/search?sort=popular" },
  { label: "Best Sellers", icon: Award, to: "/market/search" },
  { label: "New Arrivals", icon: Sparkles, to: "/market/search?sort=newest" },
  { label: "Hot Deals", icon: Zap, to: "/market/search" },
  { label: "Limited Time Offers", icon: Clock, to: "/market/search" },
];

export const DealStrip = () => (
  <div className="bg-taven-black border-y border-white/10 overflow-hidden" data-testid="deal-strip">
    <div className="flex md:hidden overflow-x-auto no-scrollbar">
      {DEALS.map((d) => (
        <Link key={d.label} to={d.to} className="shrink-0 flex items-center gap-2 px-4 py-3 text-white/90 hover:text-taven-gold border-r border-white/10 whitespace-nowrap text-xs font-bold uppercase tracking-wider">
          <d.icon className="w-4 h-4 text-taven-orange" /> {d.label}
        </Link>
      ))}
    </div>
    <div className="hidden md:flex items-center justify-center max-w-7xl mx-auto">
      {DEALS.map((d) => (
        <Link key={d.label} to={d.to} className="flex items-center gap-2 px-5 py-3.5 text-white/90 hover:text-taven-gold transition-colors text-xs font-bold uppercase tracking-wider">
          <d.icon className="w-4 h-4 text-taven-orange" /> {d.label}
        </Link>
      ))}
    </div>
  </div>
);

export default DealStrip;
